module.exports = __webpack_public_path__ + "static/media/citibanamex-logo.4161177d.png";